import { constructMediaUrl } from '../../../../api/helpers';
import { mediaThumbUrl } from '../../../../api/mediaUrls';
import { CastMember } from '../../../../api/structs';

/**
 * Where a cast member's picture is served from: the URL the engine stamped on
 * the member when it has one, and the media item's own thumbnail when it only
 * knows the id (a member loaded from a previous run carries the id alone).
 * Empty for a member with neither — the planner named them, nobody has given
 * them a face yet, and the card stands a placeholder in.
 */
export const castMemberImageUrl = (member: CastMember): string => {
  const url = (member.url || '').trim();
  if (url) return constructMediaUrl(url);
  const mediaId = (member.media_id || '').trim();
  return mediaId ? mediaThumbUrl(mediaId) : '';
};
